import { render, staticRenderFns } from "./TimeCompare.vue?vue&type=template&id=4b099d90"
import script from "./TimeCompare.vue?vue&type=script&lang=js"
export * from "./TimeCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports